import Sidebar from "../components/navigation/Sidebar";
import Topbar from "../components/navigation/Topbar";
import Footer from "../components/Footer";

const AppLayout = ({ children }) => {
  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default AppLayout;